import React from 'react';
import { useChat } from '../contexts/ChatContext';
import { Button } from './ui/button.jsx';
import { formatDistanceToNow } from 'date-fns';

const MessageSidebar = () => {
  const { conversations, currentConversation, createNewConversation, switchConversation } = useChat();

  if (!Array.isArray(conversations) || !conversations) return null;

  return (
      <div className="flex flex-col h-full bg-white dark:bg-gray-800 border-r">
        <div className="px-4 py-3 flex items-center justify-between border-b">
          <h2 className="text-lg font-semibold text-gray-700">Conversations</h2>
          <Button size="icon" variant="ghost" onClick={createNewConversation}>+</Button>
        </div>
        <div className="overflow-auto flex-1">
          {conversations.map(conv => {
            const isActive = currentConversation?.id === conv.id;
            return (
                <div
                    key={conv.id}
                    onClick={() => switchConversation(conv.id)}
                    className={`px-4 py-2 cursor-pointer hover:bg-gray-100 ${isActive ? 'bg-gray-200' : ''}`}>
                  <div className="font-medium text-gray-800">{conv.title || `Chat ${conv.id.slice(0, 4)}`}</div>
                  <div className="text-xs text-gray-500">
                    {formatDistanceToNow(new Date(conv.updatedAt), { addSuffix: true })}
                  </div>
                </div>
            );
          })}
          {conversations.length === 0 && (
              <div className="p-4 text-center text-gray-500">No conversations. + to start!</div>
          )}
        </div>
      </div>
  );
};

export default MessageSidebar; 